import { makeAutoObservable } from 'mobx';
import { RootStore } from './RootStore';

interface CartItem {
  id: string;
  title: string;
  price: number;
  quantity: number;
}

export class CartStore {
  items: CartItem[] = [];
  isLoading: boolean = false;

  constructor(private rootStore: RootStore) {
    makeAutoObservable(this);
  }

  addItem(item: Omit<CartItem, 'quantity'>) {
    const existingItem = this.items.find(i => i.id === item.id);

    if (existingItem) {
      existingItem.quantity += 1;
    } else {
      this.items.push({ ...item, quantity: 1 });
    }
  }

  removeItem(itemId: string) {
    this.items = this.items.filter(item => item.id !== itemId);
  }

  updateQuantity(itemId: string, quantity: number) {
    const item = this.items.find(i => i.id === itemId);
    if (item) {
      item.quantity = Math.max(0, quantity);
      if (item.quantity === 0) {
        this.removeItem(itemId);
      }
    }
  }

  get totalItems() {
    return this.items.reduce((sum, item) => sum + item.quantity, 0);
  }

  get totalPrice() {
    return this.items.reduce((sum, item) => sum + (item.price * item.quantity), 0);
  }

  clearCart() {
    this.items = [];
  }
}